import React, {useState} from "react"
import ReactDatePicker from "react-datepicker";
import {Container} from "./styles"
import "react-datepicker/dist/react-datepicker.css";
import {useSelector} from "react-redux";
import {selectAdminUser} from "../../app/adminUser/selectors";

const dateOptions: Intl.DateTimeFormatOptions = {
    month: 'short',
    year: 'numeric'
}

export const DatePicker = ({setDate, date}:{setDate:Function, date: Date | null}) => {
    const admin = useSelector(selectAdminUser)
    const [value, setValue] = useState<string>(
        (date || new Date()).toLocaleDateString(admin.locale || 'en', dateOptions)
    )

    // @ts-ignore
    const handleOnFocus = (e: FocusEvent<HTMLInputElement>) => {
        e.target.blur();
    }

    const handleOnChange = (d: Date | null) => {
        setValue((d || new Date()).toLocaleDateString('en', dateOptions))
        setDate(d)
    }

    const handleDeselect = (d:Date) => {
        if(d.getTime() === date?.getTime()){
            setValue(new Date().toLocaleDateString('en', dateOptions))
            setDate(null)
        }
    }

    return (
        <Container active={!!date}>
            <ReactDatePicker
                dateFormat="MMMM yyyy"
                showMonthYearPicker
                value={value}
                selected={date}
                onFocus={(e) => {handleOnFocus(e)}}
                onChange={(d) => {handleOnChange(d)}}
                onSelect={(d) => {handleDeselect(d)}}
            />
        </Container>
    );
}
